import client from './client';
import type { AWSResourceActionResponse, EC2Instance, RDSInstance } from '@/types';

// ---------- EC2 ----------

export async function fetchEC2Instances() {
  const { data } = await client.get<EC2Instance[]>('/aws/ec2');
  return data;
}

export async function startEC2Instance(instanceId: string) {
  const { data } = await client.post<AWSResourceActionResponse>(
    `/aws/ec2/${instanceId}/start`,
  );
  return data;
}

export async function stopEC2Instance(instanceId: string) {
  const { data } = await client.post<AWSResourceActionResponse>(
    `/aws/ec2/${instanceId}/stop`,
  );
  return data;
}

// ---------- RDS ----------

export async function fetchRDSInstances() {
  const { data } = await client.get<RDSInstance[]>('/aws/rds');
  return data;
}

export async function startRDSInstance(dbIdentifier: string) {
  const { data } = await client.post<AWSResourceActionResponse>(
    `/aws/rds/${dbIdentifier}/start`,
  );
  return data;
}

export async function stopRDSInstance(dbIdentifier: string) {
  const { data } = await client.post<AWSResourceActionResponse>(
    `/aws/rds/${dbIdentifier}/stop`,
  );
  return data;
}
